import React, { useRef, useState, useEffect } from 'react';
import './css/GiftBlock.css';
import { formatNumberWithCommas } from './formatIntegerWithCommas.js';
import styled, { keyframes } from 'styled-components';
import Ticket from './ticket.js';
import GiveawayTable from './giveawayTable.js';
import { Loading } from './loading.js';
import { Turl } from './tUrl.js'
import { t } from 'ttag';

const HorizontProgressBarContainer = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 6px;
  background-color:rgb(250 250 250 / 17%);
  position: relative;
  overflow: hidden;
`;

const getColor = (ssr) => {
  var clr = ["#52a84d99"]
  if (ssr > 30) clr = ["#ffde3399"]
  if (ssr > 70) clr = ["#d2404e99"]
  return clr;

}

const stripesAnimation = keyframes`
  0% { background-position: 0 0; }
  100% { background-position: 20px 0px; }
`;

const HorizontProgressBarFill = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%; /* Wider at the top */
  width: ${({ progress }) => `${progress}%`};
  transition: height 0.8s ease-out, width 0.8s ease-out; /* Animate width too */
  background: ${({ progress }) => `${getColor(progress)}`};
  /* Add a transform origin for scaling */
    background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
  animation: ${stripesAnimation} 1s linear infinite;
  transform-origin: bottom left;
`;


const HorizontProgressBar = ({ value, max }) => {
  const [progress, setProgress] = useState(0);
  const [animating, setAnimating] = useState(true);
  const animationTimeout = useRef(null);

  useEffect(() => {
    if (animating && max > 0) {
      setProgress(100); // Сначала до максимума
      animationTimeout.current = setTimeout(() => {
        setProgress(Math.min((value / max) * 100, 100));
        setAnimating(false);
      }, 800); // Задержка перед возвратом к реальному значению (настройте по желанию)
    } else if (!animating && max > 0) {
      setProgress(Math.min((value / max) * 100, 100));
    } else {
      setProgress(0);
    }

    return () => clearTimeout(animationTimeout.current); // Очистка таймаута при размонтировании
  }, [value, max, animating]);

  return (
    <HorizontProgressBarContainer>
      <HorizontProgressBarFill progress={progress} />

    </HorizontProgressBarContainer>
  );
};


const tg = window.Telegram ? window.Telegram.WebApp : null;

function GiftBlock() {

  const [mData, setmData] = useState(null);
  const hasFetchedData = useRef(false); // Ref для отслеживания первого вызова

  useEffect(() => {
    const getData = async () => {
      hasFetchedData.current = true;

      try {
        const _userData = tg ? tg.initData : null;
        let userData = { initData: _userData }

        if (userData) {
          const response = await fetch(Turl + '/api/gift', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userData)
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          let rd = await response.json();
          setmData(rd)

        } else {
          console.warn("Telegram user data not available.");
        }

      } catch (error) {
        console.error('Authentication error:', error);
      }
    };

    if (!mData && !hasFetchedData.current) {
      getData();
    }
  }, [mData]);

  if (!mData)
    return <Loading />;
  hasFetchedData.current = false;

  const tkt = mData.tickets.map(ticket => {
    return <Ticket number={ticket.name} />;
  })


  return (
    <div className='gift-block-container'>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div className="gift-block gift-pb">

          <div className="gift-pb-text-h1">
            🎁{t`BitBook Giveaway`}🎁
          </div>
          <div className="gift-pb-text-h2">
            {t`Exclusive prize draws for BitBook's most active partners`}
          </div>
        </div>
        <div className="gift-block gift-pb">
          <div className="gift-pb-text-h1">{t`Giveaway`} #{mData.round},  {t`tickets`}: {mData.maxTik}</div>
          <HorizontProgressBar value={mData.sumInv} max={100000} />
          <div className="gift-pb-text-h2" style={{ textAlign: 'left', marginTop: '20px' }}>
            {t`Your tickets for the next Giveaway:`}
          </div>

          <div className="horizontal-scroll-container">
            {tkt}
          </div>

        </div>

        <div className="gift-block gift-pb">
          <div className="gift-pb-text-h1">
            <div style={{ textAlign: "center" }}>{t`The next 1000 usdt could be yours!`}</div>
          </div>
          <div className="gift-pb-text-h2">
            <div>{t`Every 100 USDT = 1 ticket.`}</div>
            <div>{t`The more tickets you have, the higher your chances!`}</div>
          </div>
        </div>

        <div className="gift-block gift-pb" style={{ padding: 0 }}>
          <div className="gift-pb-text-h2">
            {t`Giveaway Results`}
          </div>
          <GiveawayTable data={mData.winers} pround={mData.round} />

        </div>

      </div>
    </div>
  );
}

export { GiftBlock };